import Logo from "../../../../CrombieLogo.png";

import "./loadingLogo.scss";

export const LoadingLogo = () => {
  return (
    <div className='loading-logo'>
      <img src={Logo} alt='Crombie' />
    </div>
  );
};
